import Vue from 'vue'
import VueRouter from 'vue-router'
import config from "@/config/config";

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        name: 'NotFound',
        component: () => import('@/views/common/notFound.vue'),
        meta: {
            title: '功能暂不开放'
        }
    },
    {
        path: "/",
        name: 'index',
        component: () => import('@/views/Index.vue'),
        meta: {
            title: '缘码支付-无手续费'
        }
    },
    // {
    //     path: "/createOrder",
    //     name: 'createOrder',
    //     component: () => import('@/views/pay/createOrder.vue'),
    //     meta: {
    //         title: '创建订单'
    //     }
    // },
    {
        path: "/pay",
        name: 'pay',
        component: () => import('@/views/pay/pay.vue'),
        meta: {
            title: '订单支付'
        }
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: config.projectPrefix,
})

router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title ? to.meta.title : config.projectName;
    next()
})


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
